import(/* webpackMode: "eager", webpackExports: ["EventsPanel"] */ "/app/src/app/events/EventsPanel.tsx");
